import * as React from 'react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import VendorsPageTitle from 'vendors/components/VendorsPageTitle'
import { useTranslation } from 'react-i18next'

const ServicesHeader: React.FC = () => {
  const { t } = useTranslation()
  return (
    <Box sx={{ width: '100%', maxWidth: '650px' }}>
      <VendorsPageTitle>{t('select-offered-services')}</VendorsPageTitle>
      <Box sx={{ mt: 1 }}>
        <Typography variant="body2">{t('select-offered-services-helper-text')}</Typography>
      </Box>
    </Box>
  )
}

export default ServicesHeader
